import { render, staticRenderFns } from "./roleMana.vue?vue&type=template&id=0e474ff8&scoped=true&"
import script from "./roleMana.vue?vue&type=script&lang=js&"
export * from "./roleMana.vue?vue&type=script&lang=js&"
import style0 from "./roleMana.vue?vue&type=style&index=0&id=0e474ff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e474ff8",
  null
  
)

export default component.exports